import { Actions, type SeedListData } from '@openx/types/segments';
import type { Dispatch } from 'react';
import type { Action } from './types';

export const dispatchAddItem = (dispatch: Dispatch<Action>, item: SeedListData) => {
  dispatch({ type: Actions.ADD_ITEM, payload: item });
};
